// 用戶星塵資訊
'use client';
import useUserStore from '@/store/useUserStore';
import UserInfo from '@/components/modals/user/UserInfo'; // 用戶資訊
import AsideDustInfo from '@/components/layout/aside/AsideDustInfo'; // 星塵數量
import AsideLink from '@/components/layout/aside/AsideLink'; //星塵紀錄連結
import { useEffect } from 'react';

interface Props {
    initStardust: any;
}

const AsideInfoWrapper = ({ initStardust = {} }: Props) => {
    const { setUser, user } = useUserStore();
    const { uid } = user || {};
    // balance 等欄位優先取 store（client 更新後的值），未更新前先用 server 端 initStardust，避免畫面先閃 0 才跳成正確數字
    const balance = user?.balance ?? initStardust.balance ?? 0;
    const expiringThisMonth = user?.expiringThisMonth ?? initStardust.expiringThisMonth ?? 0;
    const usedThisMonth = user?.usedThisMonth ?? initStardust.usedThisMonth ?? 0;

    useEffect(() => {
        setUser(initStardust);
    }, [uid, initStardust]);

    return (
        <div className="p-5 space-y-3">
            {uid && (
                <>
                    {/* 用戶資訊 */}
                    <UserInfo type="aside" user={user} />

                    {/* 星塵數量 */}
                    <AsideDustInfo stardust={{ balance, expiringThisMonth, usedThisMonth }} />
                </>
            )}

            {/* 星塵紀錄連結 */}
            <AsideLink uid={uid} />
        </div>
    );
};

export default AsideInfoWrapper;
